function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { UNMERGED_OUTLINES_DATA_TYPES } from '../../constants/product';
import { convertToGeoJson } from '../../utilities/map';
import { selectionToGeoJsonNoGM } from '../../workers/utilities';
import { PRODUCT_DATA, Z_INDEX, defaultSelectionColor } from './constants';
import { MAP_STATES } from './drawingControls/drawingControls';
import { computeIntersection } from './geometry';
// MapManager is an abstraction for the Google Maps API.
// Other components shouldn't deal with the Google Maps API directly, and should instead use MapManager.
var MapManager = /*#__PURE__*/ function() {
    "use strict";
    function MapManager(map) {
        _class_call_check(this, MapManager);
        this.map = map;
        this.availableDataOverlay = [];
        this.hoveredDataOverlay = [];
        this.boundariesDataOverlay = [];
        this.selectionDataOverlay = {};
        this.polygonStrokeColor = defaultSelectionColor;
        this.drawingMode = google.maps.drawing.OverlayType.RECTANGLE;
        this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingControl: false
        });
    }
    _create_class(MapManager, [
        {
            key: "clearAvailableData",
            value: function clearAvailableData() {
                this.availableDataOverlay.forEach(function(selection) {
                    selection.setMap(null);
                });
                this.availableDataOverlay = [];
            }
        },
        {
            key: "clearHoveredData",
            value: function clearHoveredData() {
                this.hoveredDataOverlay.forEach(function(selection) {
                    selection.setMap(null);
                });
                this.hoveredDataOverlay = [];
            }
        },
        {
            key: "clearBoundariesData",
            value: function clearBoundariesData() {
                this.boundariesDataOverlay.forEach(function(boundary) {
                    boundary.setMap(null);
                });
                this.boundariesDataOverlay = [];
            }
        },
        {
            key: "drawOverlayFromCoordinates",
            value: function drawOverlayFromCoordinates(coordinates, category, hovered, focused, // TODO: it's not clear what "selected" means here, it's always true
            selected) {
                var isHovered = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
                var paths = [];
                coordinates.forEach(function(polygonCoordinates) {
                    paths.push(polygonCoordinates.map(function(coordinate) {
                        return {
                            lat: coordinate[1],
                            lng: coordinate[0]
                        };
                    }));
                });
                var strokeOpacity = 0.8;
                var strokeWeight = 3;
                var fillOpacity = 0.4;
                if (focused) {
                    strokeWeight = 5.5;
                    strokeOpacity = 1.0;
                    fillOpacity = 0.5;
                } else if (hovered) {
                    strokeWeight = 4;
                    strokeOpacity = 1.0;
                    fillOpacity = 0.5;
                }
                var categoryColor = hovered || selected ? PRODUCT_DATA.entities[category].display_color : '#9b9b9b';
                var overlay = new google.maps.Polygon({
                    paths: paths,
                    strokeColor: categoryColor,
                    strokeOpacity: strokeOpacity,
                    strokeWeight: strokeWeight,
                    strokePosition: google.maps.StrokePosition.INSIDE,
                    fillColor: categoryColor,
                    fillOpacity: fillOpacity,
                    draggable: false,
                    editable: false,
                    map: this.map,
                    zIndex: Z_INDEX.COVERAGE
                });
                if (isHovered) {
                    this.hoveredDataOverlay.push(overlay);
                } else {
                    this.availableDataOverlay.push(overlay);
                }
            }
        },
        {
            key: "drawDashedOverlay",
            value: function drawDashedOverlay(coordinates) {
                var path = coordinates.map(function(param) {
                    var _param = _sliced_to_array(param, 2), lng = _param[0], lat = _param[1];
                    return {
                        lng: lng,
                        lat: lat
                    };
                });
                var overlay = new google.maps.Polyline({
                    path: path,
                    strokeColor: '#dc0822',
                    strokeOpacity: 0,
                    strokeWeight: 2,
                    map: this.map,
                    icons: [
                        {
                            icon: {
                                path: google.maps.SymbolPath.CIRCLE,
                                fillOpacity: 1,
                                scale: 2
                            },
                            offset: '0',
                            repeat: '10px'
                        }
                    ]
                });
                this.boundariesDataOverlay.push(overlay);
            }
        },
        {
            key: "drawSelectionRegion",
            value: function drawSelectionRegion(selection, currentMapState, makeSelectionActive, onContextMenuClick, selections) {
                var _this = this;
                var paths = [];
                convertToGeoJson([
                    selection
                ]).features[0].geometry.coordinates.forEach(function(polygonCoordinates) {
                    paths.push(polygonCoordinates.map(function(coordinate) {
                        return {
                            lat: coordinate[1],
                            lng: coordinate[0]
                        };
                    }));
                });
                // Default outline color and width
                var color = '#696767';
                var strokeOpacity = 0.5;
                var strokeWeight = 0.5;
                var overlay = new google.maps.Polygon({
                    paths: paths,
                    strokeWeight: 0,
                    strokePosition: google.maps.StrokePosition.INSIDE,
                    fillOpacity: 0,
                    clickable: true,
                    draggable: false,
                    editable: false,
                    map: this.map,
                    zIndex: Z_INDEX.CLICKABLE
                });
                // Overwrite shapes stroke/outline for e.g Interior etc
                if (UNMERGED_OUTLINES_DATA_TYPES.includes(selection.category_name)) {
                    strokeOpacity = 1;
                    strokeWeight = 3;
                    color = PRODUCT_DATA.entities[selection.category_name].display_color;
                }
                var outline = new google.maps.Polygon({
                    paths: paths,
                    strokeColor: color,
                    strokeOpacity: strokeOpacity,
                    strokeWeight: strokeWeight,
                    strokePosition: google.maps.StrokePosition.INSIDE,
                    fillOpacity: 0,
                    clickable: false,
                    draggable: false,
                    editable: false,
                    map: this.map,
                    zIndex: Z_INDEX.SELECTION
                });
                if (makeSelectionActive) {
                    google.maps.event.addListener(overlay, 'click', function(event) {
                        if (currentMapState !== MAP_STATES.DRAWING_RECTANGLE && currentMapState !== MAP_STATES.DRAWING_POLYGON && currentMapState !== MAP_STATES.DRAWING_POLYLINE) {
                            makeSelectionActive(selection);
                        } else {
                            google.maps.event.trigger(_this.map, 'click', event);
                        }
                    });
                }
                google.maps.event.addListener(overlay, 'contextmenu', function(event) {
                    onContextMenuClick(event, selection.id);
                });
                google.maps.event.addListener(overlay, 'mousemove', function(event) {
                    google.maps.event.trigger(_this.map, 'mousemove', event);
                });
                this.availableDataOverlay.push(overlay);
                this.availableDataOverlay.push(outline);
                // override shape add-on outline for unmerged shapes
                var addOnOutline = this.showAddonOutline(selections, selection);
                if (addOnOutline) {
                    this.availableDataOverlay.push(addOnOutline);
                }
            }
        },
        {
            key: "showAddonOutline",
            value: function showAddonOutline(selections, selection) {
                if (selection && selection.parent_selection_id && UNMERGED_OUTLINES_DATA_TYPES.some(function(str) {
                    return selection.category_name.includes(str);
                })) {
                    var parent = selections.find(function(_) {
                        return _.id === selection.parent_selection_id;
                    });
                    var parentPolygon = selectionToGeoJsonNoGM(parent).geometry;
                    var childPolygon = selectionToGeoJsonNoGM(selection).geometry;
                    var intersection = computeIntersection(parentPolygon, childPolygon);
                    var intersectionPaths = [];
                    intersection.coordinates.forEach(function(polygonCoordinates) {
                        intersectionPaths.push(polygonCoordinates[0].map(function(coordinate) {
                            return {
                                lat: coordinate[1],
                                lng: coordinate[0]
                            };
                        }));
                    });
                    return new google.maps.Polygon({
                        paths: intersectionPaths,
                        strokeColor: PRODUCT_DATA.entities[selection.category_name].display_color,
                        strokeOpacity: 1,
                        strokeWeight: 3,
                        strokePosition: google.maps.StrokePosition.INSIDE,
                        fillOpacity: 0,
                        clickable: false,
                        draggable: false,
                        editable: false,
                        map: this.map,
                        zIndex: Z_INDEX.SELECTION
                    });
                }
                return null;
            }
        }
    ]);
    return MapManager;
}();
export { MapManager };
